export default __webpack_public_path__ + "static/media/health_circle.cb07098a.svg";